import axios from 'axios';

const api_url = process.env.REACT_APP_API_URL;

export const getCertificatesList = async () => {
  return await axios.get(`${api_url}certificates/`);
};

export const addCertificate = async (name:string) => {
  return await axios.post(`${api_url}certificates/`,{name});
};
